enum LevelConstraint {
  PRODUCT = 'PRODUCT',
  VARIANT = 'VARIANT',
  INVENTORY = 'INVENTORY',
  ATOM = 'ATOM',
}

export default LevelConstraint;
